import * as React from "react";
import {useDevertoTheme} from "@/context/ThemeProvider";
import {headerHeight} from "@/styles";
import {useTheme} from "@mui/material";

const Content = (props: {children: React.ReactNode}) => {
    const devertoTheme = useDevertoTheme();
    const theme = useTheme();
    const style: React.CSSProperties = {
        padding: "0 30px",
        width: "100%",
        marginTop: headerHeight,
        paddingTop: 15,
        backgroundRepeat: "no-repeat",
        backgroundColor: theme.palette.background.default,
    };

    if (devertoTheme.background) {
        style.backgroundImage = `url(${devertoTheme.background})`;
    }
    if (devertoTheme.backgroundIsCentered) {
        style.backgroundPosition = "center";
        style.backgroundSize = "contain";
    }

    return <div style={style}>{props.children}</div>;
};

export default Content;
